module.exports = {
  fallback: 'Captcha doğrulamasını tamamlayın.',
};
